var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RemoteComponent',{attrs:{"component":"ShareBar"}})
}
var staticRenderFns = []

export { render, staticRenderFns }